import { useEffect } from 'react';

let throttleSwitch = true;
function useThrottled(
  defalut_delay: number = 1500
): [(FN?: Function, delay?: number) => Promise<void>] {
  const throttled = (FN: Function, delay: number = defalut_delay): Promise<void> => {
    if (!throttleSwitch) {
      return;
    }
    throttleSwitch = false;
    FN && FN();
    setTimeout(() => {
      throttleSwitch = true;
    }, delay);
  };

  useEffect(() => {
    return () => {
      throttleSwitch = true;
    };
  }, []);
  return [throttled];
}

export default useThrottled;
